/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WalletRouteImport } from './routes/wallet'
import { Route as WaitlistRouteImport } from './routes/waitlist'
import { Route as NotFoundRouteImport } from './routes/not-found'
import { Route as DreamPadRouteImport } from './routes/dream-pad'
import { Route as CrewRouteImport } from './routes/crew'
import { Route as ChancesRouteImport } from './routes/chances'
import { Route as BannedRouteImport } from './routes/banned'
import { Route as IndexRouteImport } from './routes/index'
import { Route as EarnIndexRouteImport } from './routes/earn/index'
import { Route as ProfileIdRouteImport } from './routes/profile/$id'
import { Route as DreamsSearchRouteImport } from './routes/dreams/search'
import { Route as DreamsCreateRouteImport } from './routes/dreams/create'
import { Route as DreamsIdRouteImport } from './routes/dreams/$id'
import { Route as DonateIdRouteImport } from './routes/donate/$id'
import { Route as DreamsMyIdRouteImport } from './routes/dreams/my/$id'

const WalletRoute = WalletRouteImport.update({
  id: '/wallet',
  path: '/wallet',
  getParentRoute: () => rootRouteImport,
} as any)
const WaitlistRoute = WaitlistRouteImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => rootRouteImport,
} as any)
const NotFoundRoute = NotFoundRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const DreamPadRoute = DreamPadRouteImport.update({
  id: '/dream-pad',
  path: '/dream-pad',
  getParentRoute: () => rootRouteImport,
} as any)
const CrewRoute = CrewRouteImport.update({
  id: '/crew',
  path: '/crew',
  getParentRoute: () => rootRouteImport,
} as any)
const ChancesRoute = ChancesRouteImport.update({
  id: '/chances',
  path: '/chances',
  getParentRoute: () => rootRouteImport,
} as any)
const BannedRoute = BannedRouteImport.update({
  id: '/banned',
  path: '/banned',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const EarnIndexRoute = EarnIndexRouteImport.update({
  id: '/earn/',
  path: '/earn/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileIdRoute = ProfileIdRouteImport.update({
  id: '/profile/$id',
  path: '/profile/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DreamsSearchRoute = DreamsSearchRouteImport.update({
  id: '/dreams/search',
  path: '/dreams/search',
  getParentRoute: () => rootRouteImport,
} as any)
const DreamsCreateRoute = DreamsCreateRouteImport.update({
  id: '/dreams/create',
  path: '/dreams/create',
  getParentRoute: () => rootRouteImport,
} as any)
const DreamsIdRoute = DreamsIdRouteImport.update({
  id: '/dreams/$id',
  path: '/dreams/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DonateIdRoute = DonateIdRouteImport.update({
  id: '/donate/$id',
  path: '/donate/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DreamsMyIdRoute = DreamsMyIdRouteImport.update({
  id: '/dreams/my/$id',
  path: '/dreams/my/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/banned': typeof BannedRoute
  '/chances': typeof ChancesRoute
  '/crew': typeof CrewRoute
  '/dream-pad': typeof DreamPadRoute
  '/not-found': typeof NotFoundRoute
  '/waitlist': typeof WaitlistRoute
  '/wallet': typeof WalletRoute
  '/donate/$id': typeof DonateIdRoute
  '/dreams/$id': typeof DreamsIdRoute
  '/dreams/create': typeof DreamsCreateRoute
  '/dreams/search': typeof DreamsSearchRoute
  '/profile/$id': typeof ProfileIdRoute
  '/earn': typeof EarnIndexRoute
  '/dreams/my/$id': typeof DreamsMyIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/banned': typeof BannedRoute
  '/chances': typeof ChancesRoute
  '/crew': typeof CrewRoute
  '/dream-pad': typeof DreamPadRoute
  '/not-found': typeof NotFoundRoute
  '/waitlist': typeof WaitlistRoute
  '/wallet': typeof WalletRoute
  '/donate/$id': typeof DonateIdRoute
  '/dreams/$id': typeof DreamsIdRoute
  '/dreams/create': typeof DreamsCreateRoute
  '/dreams/search': typeof DreamsSearchRoute
  '/profile/$id': typeof ProfileIdRoute
  '/earn': typeof EarnIndexRoute
  '/dreams/my/$id': typeof DreamsMyIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/banned': typeof BannedRoute
  '/chances': typeof ChancesRoute
  '/crew': typeof CrewRoute
  '/dream-pad': typeof DreamPadRoute
  '/not-found': typeof NotFoundRoute
  '/waitlist': typeof WaitlistRoute
  '/wallet': typeof WalletRoute
  '/donate/$id': typeof DonateIdRoute
  '/dreams/$id': typeof DreamsIdRoute
  '/dreams/create': typeof DreamsCreateRoute
  '/dreams/search': typeof DreamsSearchRoute
  '/profile/$id': typeof ProfileIdRoute
  '/earn/': typeof EarnIndexRoute
  '/dreams/my/$id': typeof DreamsMyIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/banned'
    | '/chances'
    | '/crew'
    | '/dream-pad'
    | '/not-found'
    | '/waitlist'
    | '/wallet'
    | '/donate/$id'
    | '/dreams/$id'
    | '/dreams/create'
    | '/dreams/search'
    | '/profile/$id'
    | '/earn'
    | '/dreams/my/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/banned'
    | '/chances'
    | '/crew'
    | '/dream-pad'
    | '/not-found'
    | '/waitlist'
    | '/wallet'
    | '/donate/$id'
    | '/dreams/$id'
    | '/dreams/create'
    | '/dreams/search'
    | '/profile/$id'
    | '/earn'
    | '/dreams/my/$id'
  id:
    | '__root__'
    | '/'
    | '/banned'
    | '/chances'
    | '/crew'
    | '/dream-pad'
    | '/not-found'
    | '/waitlist'
    | '/wallet'
    | '/donate/$id'
    | '/dreams/$id'
    | '/dreams/create'
    | '/dreams/search'
    | '/profile/$id'
    | '/earn/'
    | '/dreams/my/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BannedRoute: typeof BannedRoute
  ChancesRoute: typeof ChancesRoute
  CrewRoute: typeof CrewRoute
  DreamPadRoute: typeof DreamPadRoute
  NotFoundRoute: typeof NotFoundRoute
  WaitlistRoute: typeof WaitlistRoute
  WalletRoute: typeof WalletRoute
  DonateIdRoute: typeof DonateIdRoute
  DreamsIdRoute: typeof DreamsIdRoute
  DreamsCreateRoute: typeof DreamsCreateRoute
  DreamsSearchRoute: typeof DreamsSearchRoute
  ProfileIdRoute: typeof ProfileIdRoute
  EarnIndexRoute: typeof EarnIndexRoute
  DreamsMyIdRoute: typeof DreamsMyIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/wallet': {
      id: '/wallet'
      path: '/wallet'
      fullPath: '/wallet'
      preLoaderRoute: typeof WalletRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/waitlist': {
      id: '/waitlist'
      path: '/waitlist'
      fullPath: '/waitlist'
      preLoaderRoute: typeof WaitlistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dream-pad': {
      id: '/dream-pad'
      path: '/dream-pad'
      fullPath: '/dream-pad'
      preLoaderRoute: typeof DreamPadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/crew': {
      id: '/crew'
      path: '/crew'
      fullPath: '/crew'
      preLoaderRoute: typeof CrewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chances': {
      id: '/chances'
      path: '/chances'
      fullPath: '/chances'
      preLoaderRoute: typeof ChancesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/banned': {
      id: '/banned'
      path: '/banned'
      fullPath: '/banned'
      preLoaderRoute: typeof BannedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/earn/': {
      id: '/earn/'
      path: '/earn'
      fullPath: '/earn'
      preLoaderRoute: typeof EarnIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/$id': {
      id: '/profile/$id'
      path: '/profile/$id'
      fullPath: '/profile/$id'
      preLoaderRoute: typeof ProfileIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dreams/search': {
      id: '/dreams/search'
      path: '/dreams/search'
      fullPath: '/dreams/search'
      preLoaderRoute: typeof DreamsSearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dreams/create': {
      id: '/dreams/create'
      path: '/dreams/create'
      fullPath: '/dreams/create'
      preLoaderRoute: typeof DreamsCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dreams/$id': {
      id: '/dreams/$id'
      path: '/dreams/$id'
      fullPath: '/dreams/$id'
      preLoaderRoute: typeof DreamsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/donate/$id': {
      id: '/donate/$id'
      path: '/donate/$id'
      fullPath: '/donate/$id'
      preLoaderRoute: typeof DonateIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dreams/my/$id': {
      id: '/dreams/my/$id'
      path: '/dreams/my/$id'
      fullPath: '/dreams/my/$id'
      preLoaderRoute: typeof DreamsMyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BannedRoute: BannedRoute,
  ChancesRoute: ChancesRoute,
  CrewRoute: CrewRoute,
  DreamPadRoute: DreamPadRoute,
  NotFoundRoute: NotFoundRoute,
  WaitlistRoute: WaitlistRoute,
  WalletRoute: WalletRoute,
  DonateIdRoute: DonateIdRoute,
  DreamsIdRoute: DreamsIdRoute,
  DreamsCreateRoute: DreamsCreateRoute,
  DreamsSearchRoute: DreamsSearchRoute,
  ProfileIdRoute: ProfileIdRoute,
  EarnIndexRoute: EarnIndexRoute,
  DreamsMyIdRoute: DreamsMyIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
